import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "form", "name", "email", "message", "submit", "success", "error"]

  connect() {
    // Close on escape key
    this.handleEscape = (e) => {
      if (e.key === "Escape") this.close()
    }
    document.addEventListener("keydown", this.handleEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape)
  }

  open() {
    this.modalTarget.style.display = "flex"
    document.body.style.overflow = "hidden"
    this.resetForm()
    this.nameTarget.focus()
  }

  close() {
    this.modalTarget.style.display = "none"
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  resetForm() {
    this.formTarget.reset()
    this.successTarget.style.display = "none"
    this.errorTarget.style.display = "none"
    this.submitTarget.disabled = false
  }

  async submit(event) {
    event.preventDefault()

    this.submitTarget.disabled = true
    this.errorTarget.style.display = "none"

    const formData = new FormData(this.formTarget)

    try {
      const response = await fetch(this.formTarget.action, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        },
        body: formData
      })

      const data = await response.json()

      if (response.ok) {
        this.formTarget.style.display = "none"
        this.successTarget.textContent = data.success
        this.successTarget.style.display = "block"

        // Close after 3 seconds
        setTimeout(() => {
          this.close()
          this.formTarget.style.display = "block"
          this.resetForm()
        }, 3000)
      } else {
        this.errorTarget.textContent = data.error
        this.errorTarget.style.display = "block"
        this.submitTarget.disabled = false
      }
    } catch (error) {
      this.errorTarget.textContent = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
      this.errorTarget.style.display = "block"
      this.submitTarget.disabled = false
    }
  }
}
